import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { isBrowser } from "react-device-detect";
import FillAdmissionFormPage from "../components/admissionForms/FillAdmissionFormPage";

const GET_ENQUIRY_FORM_FIELDS = gql`
  query ($form_id: Int!, $institute_id: Int) {
    getEnquiryFormFields(form_id: $form_id, institute_id: $institute_id) {
      id
      field_name
      field_type_id
      field_type
      options
      is_required
      order_no
    }
  }
`;

const FETCH_GLOBALS = gql`
  query ($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      globalBranches {
        id
        branch_name
      }
    }
  }
`;

class FillAdmissionForm extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  render() {
    if (Cookies.get("token") === undefined) {
      this.props.history.push("/login");
      return null;
    }

    const { match } = this.props;
    const formId = match.params.formId ? parseInt(match.params.formId) : 0;

    const getFormFields = this.props.getEnquiryFormFields;
    const loading1 = getFormFields.loading;
    const error1 = getFormFields.error;

    const globals = this.props.globals;
    const loading2 = globals.loading;
    const error2 = globals.error;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    return (
      <div className={Cookies.get("toggle") || "wrapper"}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser === true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
            <Container fluid>
              {loading1 || loading2 ? (
                <div className="af-fill-form-container pb-5">
                   <div className="d-flex mb-4 mt-4" style={{ gap: '8px' }}>
                      <span className="af-skeleton-box w-10 h-10"></span>
                      <span className="af-skeleton-box w-10 h-10"></span>
                      <span className="af-skeleton-box w-10 h-10"></span>
                   </div>
                   <div className="mb-5">
                      <span className="af-skeleton-box w-25 h-30 mb-2"></span>
                      <span className="af-skeleton-box w-50 h-15"></span>
                   </div>
                   
                   <div className="af-skeleton-card mb-4" style={{ padding: '32px' }}>
                      <div className="af-skeleton-box w-25 h-20 mb-4"></div>
                      <Row>
                        {[1, 2, 3, 4].map(i => (
                          <Col md={6} key={i} className="mb-4">
                            <div className="af-skeleton-box w-30 h-10 mb-2"></div>
                            <div className="af-skeleton-input mb-0"></div>
                          </Col>
                        ))}
                      </Row>
                   </div>

                   <div className="af-skeleton-card mb-4" style={{ padding: '32px' }}>
                      <div className="af-skeleton-box w-25 h-20 mb-4"></div>
                      <div className="af-skeleton-box w-40 h-10 mb-2"></div>
                      <div className="af-skeleton-input w-50 mb-0"></div>
                   </div>

                   <div className="d-flex justify-content-end gap-3 mt-4">
                      <div className="af-skeleton-box w-20 h-40" style={{ borderRadius: '6px' }}></div>
                      <div className="af-skeleton-box w-20 h-40" style={{ borderRadius: '6px' }}></div>
                   </div>
                </div>
              ) : (
                <>
                  {(() => {
                    let globalsData = globals.globals;

                    if (
                      Cookies.get("userlevel") != "1" &&
                      Cookies.get("userlevel") != "2"
                    ) {
                      let globalBranches = [];
                      globalsData.globalBranches.map((item) => {
                        if (Cookies.get("branch_id") === item.id) {
                          globalBranches.push(item);
                        }
                      });
                      globalsData.globalBranches = globalBranches;
                    }

                    // Extract state data passed via React Router history
                    const stateData = this.props.location.state || {};

                    return (
                      <FillAdmissionFormPage
                        globals={globalsData}
                        getEnquiryFormFields={getFormFields}
                        stateData={stateData}
                        formId={formId}
                      />
                    );
                  })()}
                </>
              )}
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(
  compose(
    graphql(GET_ENQUIRY_FORM_FIELDS, {
      options: (props) => ({
        variables: {
          form_id: props.match.params.formId
            ? parseInt(props.match.params.formId)
            : 0,
          institute_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "getEnquiryFormFields",
    }),
    graphql(FETCH_GLOBALS, {
      options: () => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "globals",
    }),
  )(FillAdmissionForm),
);
